module.exports = __webpack_public_path__ + "img/Lucky5_Regular.5bd26696.png";